export const SearchEventType = {
  NOTES: "Search notes",
};
